module.exports = __webpack_public_path__ + "img/woyaoyou_bg_login@2x.fafb2e1b.png";